"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Enrage_OnHealthChangeEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_Enrage_OnHealthChangeEventHandlerScript = class Effect_Enrage_OnHealthChangeEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.AttributeChanged || event.args.attribute !== __1.AttributeType.Health) {
            return;
        }
        if (event.args.value <= handler.args.scriptArgs.healthThreshold) {
            container.applyEffect(sequence, handler.subject, handler.subject, new __1.DamageAmplifyEffectArgs(handler.args.scriptArgs.damageIncreasePercent), Duration_1.Duration.Permanent, true);
            container.cancelEventHandler(handler.id);
        }
    }
};
Effect_Enrage_OnHealthChangeEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Enrage_OnHealthChange")
], Effect_Enrage_OnHealthChangeEventHandlerScript);
exports.Effect_Enrage_OnHealthChangeEventHandlerScript = Effect_Enrage_OnHealthChangeEventHandlerScript;
